import "./Breadcrumbs.scss";

import React, { useMemo } from "react";
import clsx from "clsx";

import * as TreeUtils from "../../../lib/util/TreeUtils";

import Link from "../../nav/Link/Link";
import {
	Tree,
	TreeItemId,
	TreeItemPositioned,
} from "../../../lib/util/TreeUtils";

export interface BreadcrumbProps<T> {
	className: string;
	selected: boolean;
	item: TreeItemPositioned<T>;
}

export type BreadcrumbComponent<T, P> = React.ComponentType<
	BreadcrumbProps<T> & P
>;

export interface BreadcrumbsProps<T, P> {
	selected: TreeItemId;
	tree: Tree<T>;
	breadcrumbProps?: P;
	breadcrumbComponent?: BreadcrumbComponent<T, P>;
}

const DefaultBreadcrumb: BreadcrumbComponent<any, {}> = (props) => {
	const { item, ...otherProps } = props;
	const data: any = item.data;
	return (
		<Link href={data.path} {...otherProps}>
			{data.name}
		</Link>
	);
};

function Breadcrumbs<T, P>(props: BreadcrumbsProps<T, P>) {
	const { tree, selected, breadcrumbComponent, breadcrumbProps } = props;

	const items = useMemo(
		() => TreeUtils.findItem(tree, (item) => item.id === selected),
		[tree, selected],
	);

	return (
		<div className={"Breadcrumbs"}>
			<div className={"Breadcrumbs__content"}>
				{items &&
					items.map((item, index) => {
						const isSelected = item.id === selected;
						return React.createElement(
							breadcrumbComponent || (DefaultBreadcrumb as any),
							{
								key: index,
								className: clsx("Breadcrumb", isSelected && "--selected"),
								selected: isSelected,
								item: item,
								...breadcrumbProps,
							} as any,
						);
					})}
			</div>
		</div>
	);
}

export default Breadcrumbs;
